<script>
import Corporateculture from "@/views/About/Corporateculture.vue";

export default {
  name: "culture",
  data() {
    return {
      CultureList: [
        {
          Id: 1,
          title: '海邻愿景',
          description: '成为中国领先的新型饲用蛋白供应商<br>',
          Background: require('@/assets/CoporateCulture/vision.png'),
          FontColor: '#00a0fa',
          DescriptionColor: '#4d4d4d',
          ImgSize: [{ width: 19, height: 21 }],
          position: [{ x: 10.0, y: 0 }],
          ImgSizeYa: [{ width: 45.5, height: 29.5 }],
          positionYa: [{ x: 50, y: 0 }],
          ImgSizePc: [{ width: 50, height: 100 }],
          positionPc: [{ x: 0, y: 0}],
        },
        {
          Id: 2,
          title: '海邻使命',
          description: '为养殖业健康可持续发展赋能<br>',
          Background: require('@/assets/CoporateCulture/mission.png'),
          FontColor: '#00a0fa',
          DescriptionColor: '#4d4d4d',
          ImgSize: [{ width: 19, height: 21 }],
          position: [{ x: 10.0, y: 0 }],
          ImgSizeYa: [{ width: 45.5, height: 29.5 }],
          positionYa: [{ x: 50, y: 0 }],
          ImgSizePc: [{ width: 16, height: 18 }],
          positionPc: [{ x: 28, y: -3 }],
        },
        {
          Id: 3,
          title: '海邻价值观',
          description: '守正创新、合作共赢、诚信担当<br>',
          Background: require('@/assets/CoporateCulture/outlook.png'),
          FontColor: '#00a0fa',
          DescriptionColor: '#4d4d4d',
          ImgSize: [{ width: 19, height: 21 }],
          position: [{ x: 10.0, y: 0 }],
          ImgSizeYa: [{ width: 45.5, height: 29.5 }],
          positionYa: [{ x: 50, y: 0 }],
          ImgSizePc: [{ width: 19, height: 17 }],
          positionPc: [{ x: 21, y: 0 }],
        },
        {
          Id: 4,
          title: '海邻经营理念',
          description: '以品质为先，为客户提质增效 <br> 以人才为本，为员工成长增收',
          Background: require('@/assets/CoporateCulture/idea.png'),
          FontColor: '#00a0fa',
          DescriptionColor: '#4d4d4d',
          ImgSize: [{ width: 19, height: 21 }],
          position: [{ x: 10.0, y: 0 }],
          ImgSizeYa: [{ width: 45.5, height: 29.5 }],
          positionYa: [{ x: 50, y: 0 }],
          ImgSizePc: [{ width: 19, height: 17 }],
          positionPc: [{ x: 21, y: 0 }],
        },
      ],
    };
  },
  computed: {
    responsiveCultureList() {
      const screenWidth = window.innerWidth;
      return this.CultureList.map(item => {
        if (screenWidth > 1600) {
          return {
            ...item,
            AboutImgSize: item.ImgSizePc,
            AboutPosition: item.positionPc,
          };
        } else if (screenWidth < 768) {
          return {
            ...item,
            AboutImgSize: item.ImgSizeYa,
            AboutPosition: item.positionYa,
          };
        } else {
          return {
            ...item,
            AboutImgSize: item.ImgSizePc,
            AboutPosition: item.positionPc,
          };
        }
      });
    },
  },
};
</script>

<template>
  <div class="Culture">
    <div class="CultureBox">
      <div class="culture-card" v-for="(item, index) in responsiveCultureList" :key="item.Id">
        <img :src="item.Background" alt="Background" class="background-image"
             :style="{
         // width: item.AboutImgSize[0].width + '%',
          // height: item.AboutImgSize[0].height + '%',
          // position: 'absolute',
          //  left: item.AboutPosition[0].x + '%',
          // top: item.AboutPosition[0].y + '%',
        }">
        <div class="mask-image"></div>
        <div class="Culture-description">
          <h2 :style="{ color: item.FontColor ,fontWeight:400}">{{ item.title }}</h2>
          <p :style="{ color: item.DescriptionColor }" v-html="item.description "></p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "@/assets/fontsize/aboutHaiLin.less";  /* ✅ 正确引入变量定义 */

.Culture {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 2vw 0;
  font-family: 'SourceHanSansCN', sans-serif;
}

.CultureBox {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 2vw;
  width: 80vw;
  margin: 0 auto;
  max-width: 1400px;
}

.culture-card {
  width: 100%;
  aspect-ratio: 2.8/1;
  box-shadow: 0 0 0.5vw rgba(0, 0, 0, 0.1);
  position: relative;
  background-color: white;
  align-items: center;
  text-align: center;
  transition: all 0.3s ease;
  overflow: hidden;
  height:10vw;
  max-height: 205px;
}

.culture-card:hover {
  transform: scale(1.02);
}

.background-image {
  width: 50%;
  height: 100%;
  position: absolute;
  object-fit: cover;
  opacity: 1;
  top: 0;
  right: 0;

  z-index: 0;
  mask-image: linear-gradient(to right,
    transparent 0%,
    rgba(0, 0, 0, 0.3) 20%,
    rgba(0, 0, 0, 0.6) 40%,
    rgba(0, 0, 0, 0.8) 60%,
    rgba(0, 0, 0, 1) 80%,
    rgba(0, 0, 0, 1) 100%
  );
 /* -webkit-mask-image: linear-gradient(to right,
  transparent 0%,
    rgba(0, 0, 0, 0.3) 20%,
    rgba(0, 0, 0, 0.6) 40%,
    rgba(0, 0, 0, 0.8) 60%,
    rgba(0, 0, 0, 1) 80%,
    rgba(0, 0, 0, 1) 100%
  );*/
}

.mask-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right,
    rgb(245, 245, 245) 0%,
    rgb(245, 245, 245) 40%,
    rgba(245, 245, 245, 0.95) 60%,
    rgba(245, 245, 245, 0.8) 70%,
    rgba(245, 245, 245, 0.6) 80%,
    rgba(245, 245, 245, 0) 100%
  );
  z-index: 1;
  transition: background 0.6s ease;
}

.culture-card:hover .mask-image {
  background: linear-gradient(to right,
    rgb(0, 160, 250) 0%,
    rgb(0, 160, 250,0.98) 40%,
    rgba(0, 160, 250, 0.95) 60%,
    rgba(0, 160, 250, 0.8) 70%,
    rgba(0, 160, 250, 0.6) 80%,
    rgba(0, 160, 250, 0) 100%
  );
  animation: gradientSweep 0.6s ease-out forwards;
}

.culture-card:hover h2,
.culture-card:hover p {
  color: white !important;
  transition: color 0.3s ease;
}

@keyframes gradientSweep {
  0% {
    clip-path: polygon(0 0, 0 0, 0 100%, 0 100%);
  }
  100% {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  }
}

.Culture-description {
  text-align: left;
  z-index: 2;
  position: absolute;
  left: 2vw;
  top: 50%;
  transform: translateY(-50%);
  width: 80%;
}

.Culture-description h2 {
  margin: 0 0 0.8vw 0;
  position: relative;
  white-space: nowrap;
  font-size:@honor-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(0, 160, 250);
  line-height: @honor-line-height;
  font-weight: @honor-font-weight;

}

p {
  position: relative;
  z-index: 1;
  white-space: pre-line;
  word-wrap: break-word;
  font-size: @honor-text-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(77, 77, 77);
  line-height: @honor-line-height;
  font-weight: @honor-font-weight;
}

/* 为最后一个卡片的描述文字单独设置样式 */
.culture-card:last-child p {
  display: block;
  -webkit-line-clamp: unset;
  -webkit-box-orient: unset;
  overflow: visible;
  font-size: @honor-text-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(77, 77, 77);
  line-height: @honor-line-height;
  font-weight: @honor-font-weight;
}

@media screen and (min-width: 769px) and (max-width: 1600px) {
  .Culture {
    padding: 15px 0;
  }

  .culture-card {
    width: 40vw;
    height: calc(14vw + 5px);
  }

  h2 {
   /* font-size: calc(1.2vw + 8px);*/
    margin-bottom: 0.6vw;
  }

  p {
   /* font-size: calc(1vw + 6px);*/
    line-height: 1.6;
  }

  .culture-card:last-child p {
   /* font-size: calc(1vw + 6px);*/
    line-height: 1.6;
  }

  .background-image {
    mask-image: linear-gradient(to right,
      transparent 0%,
      rgba(0, 0, 0, 0.3) 25%,
      rgba(0, 0, 0, 0.6) 45%,
      rgba(0, 0, 0, 0.8) 65%,
      rgba(0, 0, 0, 1) 85%,
      rgba(0, 0, 0, 1) 100%
    );
  /*  -webkit-mask-image: linear-gradient(to right,
      transparent 0%,
      rgba(0, 0, 0, 0.3) 25%,
      rgba(0, 0, 0, 0.6) 45%,
      rgba(0, 0, 0, 0.8) 65%,
      rgba(0, 0, 0, 1) 85%,
      rgba(0, 0, 0, 1) 100%
    );*/
  }

  .mask-image {
    background: linear-gradient(to right,
      rgb(245, 245, 245) 0%,
      rgb(245, 245, 245) 45%,
      rgba(245, 245, 245, 0.95) 65%,
      rgba(245, 245, 245, 0.8) 75%,
      rgba(245, 245, 245, 0.6) 85%,
      rgba(245, 245, 245, 0) 100%
    );
  }

  .culture-card:hover .mask-image {
    background: linear-gradient(to right,
      rgb(0, 160, 250) 0%,
      rgb(0, 160, 250, 0.98) 45%,
      rgba(0, 160, 250, 0.95) 65%,
      rgba(0, 160, 250, 0.8) 75%,
      rgba(0, 160, 250, 0.6) 85%,
      rgba(0, 160, 250, 0) 100%
    );
  }
}

@media screen and (max-width: 768px) {
  .Culture {
    padding: 0;
  }

  .CultureBox {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .culture-card {
    width: 100%;
    height: 180px;
    aspect-ratio: auto;
    border-radius: 0;
  }

  .Culture-description {
    width: 65%;
    left: 20px;
  }

  h2 {

    margin-bottom: 8px;
    white-space: normal;
  }

  p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: nowrap;
  }

  .culture-card:last-child p {
    -webkit-line-clamp: 2;
  }

  .background-image {
    width: 50%;
    height: 100%;
    object-fit: cover;
    right: 0;
  }

  .mask-image {
    width: 90%;
    background: linear-gradient(to right,
      rgb(245, 245, 245) 0%,
      rgb(245, 245, 245) 50%,
      rgba(245, 245, 245, 0.95) 70%,
      rgba(245, 245, 245, 0.8) 85%,
      rgba(245, 245, 245, 0) 100%
    );
  }

  .culture-card:hover .mask-image {
    background: linear-gradient(to right,
      rgb(0, 160, 250) 0%,
      rgb(0, 160, 250, 0.98) 50%,
      rgba(0, 160, 250, 0.95) 70%,
      rgba(0, 160, 250, 0.8) 85%,
      rgba(0, 160, 250, 0) 100%
    );
  }
}
</style>
